<script setup lang="ts">
import {computed, onMounted, Ref, ref, watch} from 'vue';
import PageLayout, {type IPageNavItem} from '../../layouts/PageLayout.vue';
import {RouterView, useRoute} from 'vue-router';
import Application from "../../models/Application.ts";
import {provide} from "vue";

const route = useRoute();

const routeParams = ref({
  appId: route.params.appId,
})

const navItems = ref<IPageNavItem[]>([
  {
    name: "app.admin.apps.app.overview",
    title: "Overview",
    icon: "mdi-information",
    params: ""
  },
  {
    name: "app.admin.apps.app.users",
    title: "Allowed Users",
    icon: "mdi-account",
    params: ""
  },
  {
    name: "app.admin.apps.app.callbacks",
    title: "Callbacks",
    icon: "mdi-web",
    params: "",
  },
  {
    name: "app.admin.apps.app.email-config",
    title: "Email Whitelabeling",
    icon: "mdi-email",
    params: "",
  },
])

const loading = ref<boolean>(false)
const application = ref<Application>()
const applicationForRouteProp = computed(() => application.value)

const getApp = (id: string) => {
  loading.value = true
  Application.getApplicationById(id).then(([success, app, error]) => {
    if(success) {
      application.value = app;
    } else {
      console.error(error);
    }
  }).finally(() => {
    loading.value = false
  })
}

const deactivate = (app: Application) => {
  app.deactivate().then(([success, error]) => {
    if (success) {
      console.log("deactivating...")
      app.status = 0;
    } else {
      console.error(error)
    }
  })
}

const activate = (app: Application) => {
  app.activate().then(([success, error]) => {
    if (success) {
      console.log("activating...")
      app.status = 1
    } else {
      console.error(error)
    }
  })
}

watch(
    () => route.params?.appId,

    (newId, oldId) => {
      if (route.path.includes('/admin/apps') && route.name !== 'app.admin.apps')
        if (newId !== oldId && newId !== undefined) {
          routeParams.value.appId = newId
          getApp(route.params.appId as string)
        }

    }
)

onMounted(() => {
  getApp(route.params.appId as string)
})

provide<Ref<Application>>("application", application)
</script>

<template>
  <PageLayout v-if="!loading" :title="application?.title" icon="mdi-application" :nav-items="navItems"
              :loading="loading" show-status :status="application?.status">
    <template #tbactions>
      <v-btn prepend-icon="mdi-lock" v-if="application?.status === 1" color="red"
             variant="flat" @click="deactivate(application)">Deactivate
      </v-btn>
      <v-btn prepend-icon="mdi-lock-open" v-if="application?.status === 0" color="green"
             variant="flat" @click="activate(application)">Activate
      </v-btn>
    </template>
    <RouterView :application="applicationForRouteProp" v-if="!loading" @updated="value => application = value"></RouterView>
  </PageLayout>
</template>